import { render, staticRenderFns } from "./TierSingleModal.vue?vue&type=template&id=1da93e88"
import script from "./TierSingleModal.vue?vue&type=script&lang=ts"
export * from "./TierSingleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports